import {Button} from 'antd'
import http from '@/biz/http.mjs'
import {useOpenModal} from '@/components/Modal/index.mjs'
import {writeFileToDisk} from '@/script/file.mjs'
import runAsync from '@/script/runAsync.mjs'
import ExportDlg from '@/pages/MainPage/panes/UcList/ExportDlg.jsx'
import {useMapContext} from '@/components/MindMap/index.mjs'

const PropertiesPaneButtonExport = (props) => {
    const openModal = useOpenModal()
    const map = useMapContext()
    const selectedNodes = map.useSelectedNodes()

    if (0 === selectedNodes.size) {
        return null
    }

    const handleClick = async () => {
        const inputs = await openModal(<ExportDlg />)

        if (! inputs) {
            return
        }

        const {expUeFlag} = inputs
        const pkids = [...selectedNodes].map(n => n.data.pkid)

        const {blob, fileName} = await runAsync(
            () => http.post('/rmucs/export', {expUeFlag, pkids}),
            {action: '导出测试用例'}
        )

        const types = [{accept: {'application/msexcel': ['.xlsx']}}]
        writeFileToDisk(blob, {suggestedName: fileName, types})
    }

    return (
        <Button
            onClick={handleClick}
            {...props}
        >
            导出集成用例
        </Button>
    )
}

export default PropertiesPaneButtonExport
